<template>
    <!-- ]赎货详情 -->
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-input class="search_input search_inputBox" v-model="params.redeem_order_sn" placeholder="融资合同号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.status" placeholder="合同状态" @visible-change="getSelectList('redeemContract')">
                <el-option v-for="(list,index) in selectMap.redeemContract" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('redeemConIssuing')">
                <el-option v-for="(list,index) in selectMap.redeemConIssuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('redeemConIssuing')">
                <el-option v-for="(list,index) in selectMap.redeemConIssuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <!-- <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span> -->
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" @click="foreclosureBut"><i class="iconfont icon-xunhuan returnImg"></i>余额转预赎</el-button>
            <el-button class="funcPublicBtn" @click="returnBut"><i class="iconfont icon-yuetuihui returnImg"></i>余额退回</el-button>
        </div>
        <div class="tableBox">
            <tabletem :isShowIndex="true" :isSetCol="true" scene="purchase.redeem.details" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber">合计：</div>
            <div class="totalNumber">赎货余额:{{tot.redeem_balance}}</div>
            <!-- <div class="totalNumber">可发方数:{{tot.unpay_amount}}</div> -->
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="purchase.redeem.details" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 余额转预赎 dialog START -->
        <el-dialog v-dialog-drag title="余额转预赎" :visible.sync="foreclosureButDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_foreclosure" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="融资合同：" required>
                        <el-input  v-model="add_foreclosure.contract_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="转赎合同：" required>
                        <el-select v-model="add_foreclosure.in_purchase_id" placeholder=""  @change="changePurchase_id(add_foreclosure.purchase_id)" @visible-change="getSelectList('pledgePurchase')">
                            <el-option v-for="item in selectMap.pledgePurchase" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="融资提单：" required>
                        <el-select v-model="add_foreclosure.finance_order_id" placeholder="" @visible-change="getPledgeOrderList(add_foreclosure.in_purchase_id)">
                            <el-option v-for="item in pledgeOrderList" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易日期：" required>
                        <el-date-picker v-model="add_foreclosure.trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                   <el-form-item label="转赎账户：" required>
                       <el-input  v-model="add_foreclosure.account" disabled></el-input>
                        <!-- <el-select v-model="add_foreclosure.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item  label="收款方：" required>
                        <el-input v-model="add_foreclosure.receipt_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="流水类型：" required>
                        <el-input v-model="add_foreclosure.bill_type_text" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易方式：" required>
                        <el-input v-model="add_foreclosure.payment_type" disabled></el-input>
                        <!-- <el-select v-model="add_foreclosure.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item  label="科目名称：" prop="course_name" required>
                        <el-input  v-model="add_foreclosure.course_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="付款金额：" required>
                        <el-input v-model="add_foreclosure.pay_amount" @input.native="changeRate($event,add_foreclosure.amount)"  placeholder="" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-input v-model="add_foreclosure.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="foreclosureButDialog=!foreclosureButDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="addForeclosureBack()">付款</el-button>
            </div>
        </el-dialog>
        <!-- 余额转预赎 dialog START -->
        <el-dialog v-dialog-drag title="余额退回" :visible.sync="returnButDialog" class="eldialog no_print eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_return" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <el-form-item label="融资合同：" required>
                        <el-input  v-model="add_return.contract_no" disabled></el-input>
                        <!-- <el-select v-model="add_return.purchase_id" placeholder="" disabled @change="changePurchase_id(add_return.purchase_id)" @visible-change="getSelectList('pledgePurchase')">
                            <el-option v-for="item in selectMap.pledgePurchase" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item label="交易日期：" required>
                        <el-date-picker v-model="add_return.trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                   <el-form-item label="退入账户：" required>
                        <el-select v-model="add_return.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="收款方：" prop="companyName" required>
                        <el-input v-model="add_return.companyName" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="流水类型：" prop="bill_type_text" required>
                        <el-input v-model="add_return.bill_type_text" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="交易方式：" required>
                         <el-input v-model="add_return.payment_type" disabled></el-input>
                        <!-- <el-select v-model="add_foreclosure.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item  label="科目名称：" prop="course_name" required>
                        <el-input  v-model="add_return.course_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="付款金额：" required>
                        <el-input v-model="add_return.pay_amount" @input.native="changeRate($event,add_return.amount)"  disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="备注信息：">
                        <el-input v-model="add_return.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="returnButDialog=!returnButDialog">取消</el-button>
                <el-button  class="publicBtn dialogBtn"  @click="addReturn()">付款</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue';
    import pagination from '../../../../components/pagination.vue';
    const initPayForm={
        contract_no:"",
        in_purchase_id:"",
        issuing_id:"",
        trading_time:new Date(),
        pay_amount:"",
        account:"合同余额账户",
        payment_type:"系统内转",
        remark:"",
        course_name:"合同余额转预赎",
        bill_type_text:"支出",
    };
    const returnPayForm={
        contract_no:"",
        trading_time:new Date(),
        pay_amount:"",
        account_id:"",
        payment_type:"系统内转",
        remark:"",
        companyName: localStorage.dw_erp_company_name,
        course_name:"融资合同余额退回",
        bill_type_text:"收入",
    };
    export default {
        data(){
            return {
                module: localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    redeem_order_sn:"",
                    status:"",
                    issuing_id:'',
                },
                last_page:1,
                total:0,
                tot:{},
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                isGlobal:false,
                tableLoading:false,
                selectRow:[],
                tableCol:[
                    {colName:"合同日期",colKey:"contract_time",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"融资合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"开证公司",colKey:"payer",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"合同状态",colKey:"status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"保证金",colKey:"deposit",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,
                    htmlNodeFunc(row) {
                        let color = row['deposit_status'] ==0 ? 'red' : '';
                            return `<span>${row['deposit']}</span><span style="color:${color}">(${row['deposit_status_text']})</span>`;
                    }},
                    {colName:"融资金额",colKey:"finance_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"计息费用",colKey:"interest",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"实付金额",colKey:"redeem_payment",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"剩余货值金额",colKey:"inventory_balance",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同余额",colKey:"contract_balance",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,
                    htmlNodeFunc(row) {
                        let color = row['contract_balance'] >0 ? 'red' : '';
                            return `<span style="color:${color}">${row['contract_balance']}</span>`;
                    }},
                    {colName:"赎货记录",colKey:"redeem_log_id",colWidth:80,isSetWidth:true,isCanClick:true,isColor:true,isHideShowClickImg:true,},
                ],
                list:[],
                selectMap:{
                    redeemstatus:[],
                    redeemsales:[],
                    paymentType:[],
                    account:[],
                    user:[],
                    redeemConIssuing:[],
                    inventoryissuing:[],
                    redeemContract:[],
                    pledgePurchase:[]
                },
                foreclosureButDialog:false,
                pledgeOrderList:[],
                add_foreclosure:this.$cloneJson(initPayForm),
                returnButDialog:false,
                add_return:this.$cloneJson(returnPayForm),
                issuing_id:'',
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getSelectList('redeemContract');
            this.getSelectList('redeemConIssuing');
            this.issuing_id = sessionStorage.getItem("STORE_ISSUING_ID")
            sessionStorage.removeItem("STORE_ISSUING_ID")
            if(this.issuing_id){
                this.params.issuing_id = [Number(this.issuing_id)];
            }
            this.getList();

        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                // this.params.issuing_id = this.issuing_id;
                this.$postColumnList("/erp/purchase.redeem.details",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    // this.balance = res.data.data.issuing_balance;
                    this.tot= res.data.data.total;
                    this.list=res.data.data.list.data;
                    let obj ={
                        sales_count:res.data.data.sales_count,
                        advance_count:res.data.data.advance_count
                    }
                    this.$emit('child-num',obj)
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        if(item.status_text=='待付款'){
                            item.baseColor='red';
                        }
                        item.redeem_log_id = '查看记录'
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            getRow(row){
                this.selectRow=row;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name =='redeem_log_id'){
                    sessionStorage.removeItem("TOSHORTDETAIL")
                    sessionStorage.setItem("TOSHORTDETAIL",1)
                    sessionStorage.removeItem("STORE_CONTRACT_NO")
                    sessionStorage.setItem("STORE_CONTRACT_NO",obj.row.contract_no)
                    this.$root.$children[0].$children[0].removeNameTab('赎货详情',
                    {
                        name: '赎货详情',
                        label: '赎货详情',
                        content: 'foreclosureDetail'
                    });
                    // this.$root.$children[0].$children[0].addTab({
                    //     name: '赎货详情'+obj.id,
                    //     label: '赎货详情',
                    //     content: 'foreclosureDetail'
                    // });
                }
            },
            changePurchase_id(){
                this.pledgeOrderList =[];
                this.add_foreclosure.finance_order_id=''
            },
            getPledgeOrderList(purchase_id){
                this.postFunc('/erp/pledge.order.option',{purchase_id:purchase_id},res=>{
                    this.pledgeOrderList = res.data.data
                })
            },
            //余额转预赎
            foreclosureBut(){
                if(this.selectRow.length<1){
                    this.tip('请选择数据',"warning");
                    return
                }else if(this.selectRow.length>1){
                    this.tip('请选择单条数据',"warning");
                    return
                }else if(this.selectRow[0].contract_balance==0){
                    this.tip('合同余额为0',"warning");
                    return
                }
                this.getPledgeOrderList(this.selectRow[0].id);
                this.add_foreclosure.receipt_name = this.selectRow[0].payer;
                this.add_foreclosure.contract_no = this.selectRow[0].contract_no;
                this.add_foreclosure.pay_amount = this.selectRow[0].contract_balance;
                this.foreclosureButDialog = !this.foreclosureButDialog;
            },
            //余额转预赎付款
            addForeclosureBack(){
                let obj={}
                obj.out_purchase_id = this.selectRow[0].id;
                obj.in_purchase_id = this.add_foreclosure.in_purchase_id;
                obj.in_finance_order_id = this.add_foreclosure.finance_order_id;
                obj.bill_time  = this.formatTimeZero(this.add_foreclosure.trading_time);
                obj.course_title  = this.add_foreclosure.course_name;
                obj.amount  = this.add_foreclosure.pay_amount;
                obj.remark  = this.add_foreclosure.remark;
                this.postFunc('/erp/redeem.balance.cube',obj,res=>{
                    this.getList();
                    this.tip('付款成功',"success")
                    this.foreclosureButDialog = !this.foreclosureButDialog;

                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //余额退回
            returnBut(){
                if(this.selectRow.length<1){
                    this.tip('请选择数据',"warning");
                    return
                }else if(this.selectRow.length>1){
                    this.tip('请选择单条数据',"warning");
                    return
                }else if(this.selectRow[0].contract_balance==0){
                    this.tip('合同余额为0',"warning");
                    return
                }
                this.add_return.contract_no = this.selectRow[0].contract_no;
                this.add_return.pay_amount = this.selectRow[0].contract_balance;
                this.returnButDialog = !this.returnButDialog;
            },
            // 余额退回付款
            addReturn(){
                let obj={}
                obj.out_purchase_id = this.selectRow[0].id;
                obj.account_id = this.add_return.account_id
                obj.trading_time  = this.formatTimeZero(this.add_return.trading_time);
                obj.amount  = this.add_return.pay_amount;
                obj.remark  = this.add_return.remark;
                this.postFunc('/erp/redeem.balance.return',obj,res=>{
                     this.getList();
                    this.tip('付款成功',"success")
                    this.returnButDialog = !this.returnButDialog;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            changeRate(e,input){
                e.target.value=(e.target.value.match(new RegExp("^\\-?\\d*(\\.?\\d{0,2})","g"))[0]) || null
                let inputs=e.target.value;
                this.add_foreclosure.pay_amount=inputs;
            },
            //导出 提前赎货单
            exportExcel(){
                this.$exportExecl("/erp/advance.redeem.info.export","提前赎货单",{id:this.form_params.id})
            },
            excelExport(){
                this.$exportExecl("/erp/advance.redeem.export","提前赎货",this.params)
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    redeem_amount:2,
                },total=>{
                });
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "foreclosureButDialog":function(val){
                if(!val){
                    this.add_foreclosure = this.$cloneJson(initPayForm);
                }
            },
            "returnButDialog":function(val){
                if(!val){
                    this.add_return =  this.$cloneJson(returnPayForm);
                }
            }
        }
    }
</script>
<style  scoped lang="scss">
.btnBox{
    display: flex;
    .payBtnDiv{
        padding: 5px 20px 10px 0;display: inline-block;border-right: 2px solid #eee;
    }
    .balanceDiv{
        display: inline-block;
        .banCheckboxGroup{
            display: flex;
            margin-left: 20px;
        }
        .balanceItem{
            margin-left: 20px;
            line-height: 24px;
            font-weight: 600;
            font-size: 14px;
            margin-top: 7px;
            .balanceIcon{
                position: relative;
                top: 5px;
                margin-right: 1px;
            }
            .balanceImg{
                width: 20px;
                height: 19px;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
            /*重写radio样式*/
            /deep/ .el-radio__inner{
                width: 20px;
                height: 20px;
                border-radius: 2px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner:after{
                width: 6px;
                height: 13px;
                box-sizing: content-box;
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                left: 6px;
                position: absolute;
                border-radius: 2px;
                transform-origin: center;
                transform: rotate(45deg);
                background: none;
                top: 0;
            }
        }
    }
}
.editBtnList{padding:10px;
    .editTax{float: left;margin-right:20px;}
    .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
    .editTaxinput{float: left;width:100px;}
    .editBtn{float: right;}
}
.returnImg{font-size: 16px;}
</style>